<template>
	<div :class="$style.wrapper">
		<div :class="$style.title">{{ title }}</div>
		<div class="mt-2">
			<span :class="$style.current">{{ current }}</span>
			<span :class="$style.total">/{{ total }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PassportWidget',
	props: {
		title: String,
		current: Number,
		total: Number,
	},
}
</script>

<style module lang="scss">
.wrapper {
	background: #ffffff;
	font-family: 'Manrope', sans-serif;
	padding: 13px 16px;
}

.title {
	font-weight: 700;
	font-size: 10px;
	line-height: 16px;

	text-transform: uppercase;

	color: #4f4f4f;
}

.current {
	font-weight: 600;
	font-size: 18px;
	line-height: 27px;

	color: #000000;
}

.total {
	font-weight: 700;
	font-size: 12px;
	line-height: 16px;

	color: #000000;

	opacity: 0.5;
}
</style>
